import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MyLearning = () => {
  const [user, setUser] = useState(null);
  const [courses, setCourses] = useState([]);
  const [showCodeForm, setShowCodeForm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate fetching user data from localStorage
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    // Simulate fetching courses data (only Bootcamp Course)
    const mockCourses = [
      { id: 3, title: "Bootcamp Course", progress: "0%", requiresCode: true },
    ];
    setCourses(mockCourses);
  }, []);

  const handleContinueLearning = (course) => {
    if (course.requiresCode) {
      setShowCodeForm(true);
    } else {
      // Navigate directly for courses without code requirement (placeholder)
      console.log(`Continuing ${course.title}`);
    }
  };

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    const code = e.target.code.value;
    if (code === "2356") {
      setShowCodeForm(false);
      navigate("/bootcamp"); // Navigate to Bootcamp.jsx page
    } else {
      alert("Incorrect code. Please enter the correct 4-digit code (e.g., 2356).");
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-blue-600 mb-6">My Learning</h1>

      {user ? (
        <div>
          <p className="text-lg text-gray-700 mb-4">
            Welcome, {user.name}! Here are your enrolled courses:
          </p>

          {courses.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {courses.map((course) => (
                <div
                  key={course.id}
                  className="bg-gradient-to-br from-gray-100 to-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200"
                >
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    {course.title}
                  </h2>
                  <p className="text-gray-600 mb-4">Progress: {course.progress}</p>
                  <button
                    onClick={() => handleContinueLearning(course)}
                    className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors duration-300 font-medium shadow-md hover:shadow-lg"
                  >
                    Continue Learning
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-600">You have no enrolled courses yet.</p>
          )}

          {showCodeForm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                  Enter 4-Digit Access Code
                </h2>
                <form onSubmit={handleCodeSubmit} className="space-y-4">
                  <input
                    type="text"
                    name="code"
                    maxLength="4"
                    pattern="[0-9]{4}"
                    required
                    className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter 4-digit code"
                    autoFocus
                  />
                  <div className="flex justify-end space-x-4">
                    <button
                      type="button"
                      onClick={() => setShowCodeForm(false)}
                      className="px-4 py-2 text-gray-600 hover:text-gray-800"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-300"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      ) : (
        <p className="text-red-500">
          Please log in to view your learning progress.
        </p>
      )}
    </div>
  );
};

export default MyLearning;